import { extractSecureNoteTitleFromHtml } from '../extractSecureNoteTitleFromHtml';

export const extractSecureNoteTitle = (
  body: string,
  noteId: string,
  {
    extractFromHtml = extractSecureNoteTitleFromHtml,
    extractFromMarkdown = () => '',
    format,
  }: {
    extractFromHtml?: (body: string, noteId: string) => string;
    extractFromMarkdown?: (body: string, noteId: string) => string;
    format: 'html' | 'markdown';
  },
) => {
  if (!body || !noteId) {
    return '';
  }

  if (format === 'markdown') {
    return extractFromMarkdown(body, noteId);
  }

  return extractFromHtml(body, noteId);
};
